import { AppState } from '../store/reducers';
import { Store, Action } from 'redux';
import { Dispatch } from 'react-redux';

export default (store: Store<AppState>) => (next: Dispatch<Action>) => (
  action: Action
) => {
  try {
    return next(action);
  } catch (NetworkException) {
    console.error('Network error', NetworkException);
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/middlewares/authMiddleware.ts